import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {} from 'react-bootstrap';
import { Messager, Menu, MenuItem, MenuSep, SideMenu } from 'rc-easyui';
import { Form, Button, Accordion, Icon } from 'semantic-ui-react';

//alert
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

/** Action **/
import { updateFindFrameTargetData } from '../../actions/find/frameFindAction';
import { signUser } from '../../actions/authActions';
import {
  setIsEditMode,
  AddDetialJsonData,
} from '../../actions/transOperationActions';
import {
  setIsShowFindAllViewInput,
  setIsShowFindAllViewReplace,
} from '../../actions/transOperation_find_Actions';
import {
  set_subtitles_Left,
  set_viewWidth,
} from '../../actions/viewOperationActions';
import {
  show_source_language,
  hide_source_language,
  show_hide_Shot_Change,
} from '../../actions/editTableActions';
import { showHideMultipleView } from '../../actions/find/mutileFindAction';
import { showHidePositionList } from '../../actions/find/positionFindAction';
import { setIsEdit } from '../../actions/subtypeActions';
// import TimecodeShiftView from "../translations/objects/TimecodeShiftView";
import TimeLinePop from '../translations/objects/TimeLinePop';

import {
  showFindPositionAndAlign,
  showFrameSplitError,
} from '../../actions/findActions';
import { setTableColWidth, setReadonly } from '../../actions/editTableActions';

import Popup from 'reactjs-popup';
import ImportView from '../import/ImportView';
import ExportView from '../import/ExportView';
import Versions from '../translations/versions/Versions';
import TimecodeShiftMainView from './TimecodeShift/TimecodeShiftMainView';

import Spinner from '../common/Spinner';
import ZeroTimeMainView from './ZeroTime/ZeroTimeMainView';
import { SubtitleContext } from '../../contexts/SubtitleContext';

class TranslationsNavbar extends Component {
  constructor(props) {
    super(props);

    this.ShowSource = 0;
    this.isBigShow = false;

    this.lineNumberInput = React.createRef();

    this.projectIndex = 0; //專案index
    this.projectprojectData = {}; //專案資料

    this.state = {
      //兩組可以儲存的快捷鍵
      isShowHotKeyEventView: false,
      PlayPauseHoykey: parseInt(localStorage.getItem('PlayPauseHoykey')),
      PlayFromSelectedRow: parseInt(
        localStorage.getItem('PlayFromSelectedRow')
      ),

      lineNum: null,

      loading: false,

      isDialogOpen: false,

      files: [],

      autoOperation: false,

      timerSeconds: 3,

      isShowPhoneNav: false,

      isShowSourceLanguage: false,

      isShowShotChangeLanguage: false,

      isShowVersionsView: false,

      isShowGoToLine: false,
      /**
       * TimeLinePop 相關
       * */
      isShowTimeLinePop: false, //顯示Alert
      TimeLinePopMessage: '', //Alert 訊息

      /**
       * TimecodeShift 相關
       * */
      isShowTimecodeShiftView: false,

      /**
       * Zero time 相關
       * */
      isShowRunZerotime: false,

      /**
       * 輸入 相關
       * */
      isShowImportView: false,

      /**
       * 輸出 相關
       * */
      isShowExportView: false,

      activeIndex: 0,
      menus: [
        {
          text: 'Manage',
          children: [
            {
              text: 'Import',
            },
            {
              text: 'Export',
            },
            {
              text: 'Complete',
            },
          ],
        },
        {
          text: 'Edit',
          children: [
            {
              text: 'Timecode shift',
            },
            {
              text: 'Adjust Frame Split',
            },
            {
              text: 'Adjust Frame Gap Error',
            },
            {
              text: 'Run Zerotime',
            },
          ],
        },
        {
          text: 'File',
          children: [
            {
              text: 'Versions',
            },
          ],
        },
        {
          text: 'Find',
          children: [
            {
              text: 'Go to line',
            },
            {
              text: 'Go To Timeline',
            },
            {
              text: 'Find',
            },
            {
              text: 'Find and Replace',
            },
            {
              text: 'Multiple Find and Replace',
            },
            {
              text: 'Find Position and align',
            },
            {
              text: 'Frame Split Error',
            },
            {
              text: 'Frame Gap Error',
            },
            {
              text: 'Shot Change Error',
            },
            {
              text: 'Check CPS',
            },
          ],
        },
        {
          text: 'View',
          children: [
            {
              text: '100%',
            },
            {
              text: '150%',
            },
            {
              text: 'Show/Hide source',
            },
            {
              text: 'Show/Hide Shot change',
            },
            {
              text: 'Copy to source',
            },
            {
              text: 'Style check',
            },
            // {
            //     text: "Remove source"
            // }
          ],
        },
        {
          text: 'Help',
          children: [
            {
              text: 'HotKeys',
            },
          ],
        },
      ],
    };

    this.showNav = this.showNav.bind(this);
    this.prompt = this.prompt.bind(this);
    this.goToTimeline = this.goToTimeline.bind(this);

    // this.fileMenu = this.fileMenu.bind(this);
    this.findAll = this.findAll.bind(this);
    this.findAllReplace = this.findAllReplace.bind(this);
    this.closeTimeLineAlert = this.closeTimeLineAlert.bind(this);

    //客制取代
    this.multipleFindReplace = this.multipleFindReplace.bind(this);
    this.findPositionAndAlign = this.findPositionAndAlign.bind(this);
    this.frameSplitError = this.frameSplitError.bind(this);

    //視窗更新
    this.setVideoViewWidth = this.setVideoViewWidth.bind(this);

    //輸入檔案
    this.openImportView = this.openImportView.bind(this);
    this.closeImportView = this.closeImportView.bind(this);

    //輸出
    this.openExportView = this.openExportView.bind(this);
    this.closeExportView = this.closeExportView.bind(this);

    //處理按鈕
    this.handleItemClick = this.handleItemClick.bind(this);

    //版本
    this.closeVersionsView = this.closeVersionsView.bind(this);

    //Timecode shift
    this.closeTimecodeShiftView = this.closeTimecodeShiftView.bind(this);

    //快捷鍵
    this.PlayPauseHoykeyonChange = this.PlayPauseHoykeyonChange.bind(this);
    this.PlayFromSelectedRowChange = this.PlayFromSelectedRowChange.bind(this);
    this.closeHotKeyEventView = this.closeHotKeyEventView.bind(this);

    this.handleClick = this.handleClick.bind(this);
    this.setLoading = this.setLoading.bind(this);
  }

  setLoading = (qloading) => {
    this.setState({ loading: qloading });
  };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };
  /** 調整Frame 錯誤*/
  runAdjustFrameSplit = async () => {
    await this.props.runAdjustFrameSplit();
  };

  /**快捷 */
  PlayPauseHoykeyonChange = async () => {
    if (this.state.PlayPauseHoykey === 1) {
      this.setState({ PlayPauseHoykey: 0 });
      localStorage.setItem('PlayPauseHoykey', 0);
    }

    if (this.state.PlayPauseHoykey === 0) {
      this.setState({ PlayPauseHoykey: 1 });
      localStorage.setItem('PlayPauseHoykey', 1);
    }
  };
  PlayFromSelectedRowChange = () => {
    if (this.state.PlayFromSelectedRow === 1) {
      this.setState({ PlayFromSelectedRow: 0 });
      localStorage.setItem('PlayFromSelectedRow', 0);
    }

    if (this.state.PlayFromSelectedRow === 0) {
      this.setState({ PlayFromSelectedRow: 1 });
      localStorage.setItem('PlayFromSelectedRow', 1);
    }
  };

  /**
   * 選單
   * */
  async handleItemClick(item) {
    let newHeight = 0;
    let newHeight2 = 0;

    let source_language_title;
    if (this.state.isShowSourceLanguage === false) {
      source_language_title = 'Show source';
    } else {
      source_language_title = 'Hide source';
    }
    let orgisShowSourceLanguage = this.state.isShowSourceLanguage;

    switch (item.text) {
      case 'Timecode shift':
        this.props.openTimecodeShiftView();
        // this.setState({ isShowTimecodeShiftView: true });
        break;

      case 'Run Zerotime':
        this.props.openRunZerotimeView();
        // this.setState({ isShowRunZerotime: true });
        break;

      case 'Adjust Frame Split':
        confirmAlert({
          title: 'WARNING',
          message: `Start Adjust Frame Split?`,
          buttons: [
            {
              label: 'Ok',
              onClick: async () => {
                this.props.runAdjustFrameSplit();
              },
            },
            {
              label: 'Cancel',
            },
          ],
        });
        break;

      case 'Adjust Frame Gap Error':
        this.props.adjustFrameGapError();
        // confirmAlert({
        //     title: 'WARNING',
        //     message: `Start Adjust Frame Gap Error?`,
        //     buttons: [
        //         {
        //             label: 'Ok',
        //             onClick:async () =>  {
        //                 this.props.runAdjustFrameGapError();
        //             }
        //         },
        //         {
        //             label: 'Cancel'
        //         }
        //     ]
        // });
        break;
      case 'Import':
        this.openImportView();
        break;
      case 'Export':
        this.props.openExportView();
        break;
      case 'Complete':
        this.props.sendComplete();
        break;
      case 'Go to line':
        this.props.promptGoToLine();
        // this.prompt();
        break;
      case 'Go To Timeline':
        this.goToTimeline();
        break;
      case 'Find':
        this.props.findAll();
        break;
      case 'Find and Replace':
        this.props.findAllReplace();
        // this.findAllReplace();
        break;
      case 'Multiple Find and Replace':
        this.props.multipleFindReplace();
        break;
      case 'Find Position and align':
        this.props.findPositionAndAlign();
        // this.findPositionAndAlign();
        break;
      case 'Frame Split Error':
        this.props.frameSplitError();
        // this.frameSplitError();
        break;

      /**
       * netflix規則
       * */
      case 'Frame Gap Error':
        this.props.frameGapError();
        break;

      /**
       * Shot Change Error 規則
       * */
      case 'Shot Change Error':
        this.props.shotChangeError();
        break;

      /**
       * netflix 的 CPS
       * */
      case 'Check CPS':
        this.props.frameCPSError();
        break;
      /**
       * File
       * */
      case 'Versions':
        this.props.showVersions();
        //this.setState({ isShowVersionsView: true });
        break;

      /**
       * View
       * */
      case '100%':

      var defWidth = 500; 

        //取得原本的影片尺寸
        if (this.projectprojectData !== {}) {
          const { video } = this.projectprojectData;
          const { WidthVal, HeightVal } = video;
          newHeight = (defWidth * HeightVal) / WidthVal;
          newHeight2 = (600 * HeightVal) / WidthVal;
        }

        this.isBigShow = false;

        await this.props.set_subtitles_Left(defWidth);
        await this.props.set_viewWidth(defWidth, newHeight);

        //設定表格的col寬度
        await this.props.setTableColWidth(
          window.innerWidth - this.props.viewOperation.subtitles_Left - 100,
          this.ShowSource,
          this.props.editTable
        );

        //設定文字大小
        await this.props.setFontSize(100);

        break;

      case '150%':
        //取得原本的影片尺寸
        if (this.projectprojectData !== {}) {
          const { video } = this.projectprojectData;
          const { WidthVal, HeightVal } = video;
          newHeight = (458 * HeightVal) / WidthVal;
          newHeight2 = (600 * HeightVal) / WidthVal;
        }

        this.isBigShow = true;

        await this.props.set_subtitles_Left(600);
        await this.props.set_viewWidth(600, newHeight2);

        //設定表格的col寬度
        await this.props.setTableColWidth(
          window.innerWidth - this.props.viewOperation.subtitles_Left - 100,
          this.ShowSource,
          this.props.editTable
        );

        //設定文字大小
        await this.props.setFontSize(150);

        break;

      case 'Show/Hide source':
        if (this.props.editTable.colHeaders.includes('Source') === false) {
          await this.props.show_source_language(
            this.props.editTable.columns,
            this.props.editTable
          );

          this.ShowSource = 1;
          await this.props.setTableColWidth(
            window.innerWidth - this.props.viewOperation.subtitles_Left - 100,
            1,
            this.props.editTable
          );
        } else {
          await this.props.hide_source_language(
            this.props.editTable.columns,
            this.props.editTable
          );

          this.ShowSource = 0;
          await this.props.setTableColWidth(
            window.innerWidth - this.props.viewOperation.subtitles_Left - 100,
            0,
            this.props.editTable
          );
        }
        await this.setState({ isShowSourceLanguage: !orgisShowSourceLanguage });

        this.props.reflashTable();
        break;

      case 'Show/Hide Shot change':
        // if ( this.props.editTable.colHeaders.includes('Shot change') === false) {
        //   await this.props.show_hide_Shot_Change(
        //     this.props.editTable.columns,
        //     true,
        //     this.props.editTable
        //   );

        //   await this.props.setTableColWidth(
        //     window.innerWidth - this.props.viewOperation.subtitles_Left - 100,
        //     2,
        //     this.props.editTable
        //   );
        // } else {
        //   await this.props.show_hide_Shot_Change(
        //     this.props.editTable.columns,
        //     false,
        //     this.props.editTable
        //   );

        //   await this.props.setTableColWidth(
        //     window.innerWidth - this.props.viewOperation.subtitles_Left - 100,
        //     0,
        //     this.props.editTable
        //   );
        // }

        const isShow = !this.props.editTable.colHeaders.includes('Shot change');

        await this.props.show_hide_Shot_Change(
          this.props.editTable.columns,
          isShow,
          this.props.editTable
        );

        await this.props.setTableColWidth(
          window.innerWidth - this.props.viewOperation.subtitles_Left - 100,
          0,
          this.props.editTable
        );

        await this.setState({
          isShowShotChangeLanguage: isShow,
        });

        this.props.reflashTable();
        break;

      case 'Copy to source':
        this.props.sendCopyToSource();
        break;

      case 'Style check':
        //進行檢查
        this.props.sendRunTargetCheck();
        break;

      case 'Remove source':
        //this.props.senddeleteSource();
        break;

      /** Help */

      case 'HotKeys':
        this.setState({ isShowHotKeyEventView: true });
        return;

        confirmAlert({
          customUI: ({ onClose }) => {
            return (
              <div className='custom-ui'>
                <div>
                  Play /Pause :{/* ctrl + ↓ (Mac: command + ↓) */}
                  <div style={{ paddingLeft: '10px' }}>
                    <input
                      type='radio'
                      name='PlayPauseHoykey'
                      value={'Shift + Space'}
                      checked={this.state.PlayPauseHoykey === 0 ? true : false}
                      onChange={() => {
                        this.setState({ PlayPauseHoykey: 0 });
                        localStorage.setItem('PlayPauseHoykey', 0);
                      }}
                      onClick={() => {
                        this.setState({ PlayPauseHoykey: 0 });
                        localStorage.setItem('PlayPauseHoykey', 0);
                      }}
                    />
                    Shift + Space
                  </div>
                  <div style={{ paddingLeft: '10px' }}>
                    <input
                      type='radio'
                      name='PlayPauseHoykey'
                      value={'Ctrl + ↓'}
                      checked={this.state.PlayPauseHoykey === 1 ? true : false}
                      onChange={() => {
                        this.setState({ PlayPauseHoykey: 1 });
                        localStorage.setItem('PlayPauseHoykey', 1);
                      }}
                      onClick={() => {
                        this.setState({ PlayPauseHoykey: 1 });
                        localStorage.setItem('PlayPauseHoykey', 1);
                      }}
                    />
                    Ctrl + ↓
                  </div>
                </div>
                <div>
                  Play From Selected Row : ctrl + &rarr; (Mac: command + &rarr;)
                  <div style={{ paddingLeft: '10px' }}>
                    <input
                      type='radio'
                      name='PlayFromSelectedRow'
                      value={'Ctrl + Space '}
                      checked={
                        this.state.PlayFromSelectedRow === 0 ? true : false
                      }
                      onChange={this.PlayFromSelectedRowChange}
                    />
                    Ctrl + Space
                  </div>
                  <div style={{ paddingLeft: '10px' }}>
                    <input
                      type='radio'
                      name='PlayFromSelectedRow'
                      value={'Ctrl + left'}
                      checked={
                        this.state.PlayFromSelectedRow === 1 ? true : false
                      }
                      onChange={this.PlayFromSelectedRowChange}
                    />
                    ctrl + &rarr;
                  </div>
                </div>
                <div>
                  Jump Backward / Forward 5 sec. : shift + &larr;/ &rarr;
                </div>
                <div>Pause At Selected Row : Alt + p (Mac: shift + p)</div>
                <hr />
                <div>Capture Timecode : Enter</div>
                <hr />
                <div>Insert Row Above : ctrl + i (Mac: command + i)</div>
                <div>Delete Row : ctrl + D (Mac: command + D)</div>
                <div>Row Split : ctrl + alt + s (Mac: control + shift + s)</div>
                <div>Row Merge : ctrl + alt + m (Mac: control + shift + m)</div>
                <hr />
                <div>Italic : alt + i (Mac: shift + i)</div>
                <div>Add Music Note : alt + m (Mac: shift + m)</div>
                <hr />
                <div>
                  Position Left/Right : alt + &larr;/ &rarr; (Mac: option +
                  &larr;/ &rarr;)
                </div>
                <div>Position Up/Down : alt + ↑/↓ (Mac: option + ↑/↓)</div>
                {/*<div>*/}
                {/*    Align Left / Right (SCC)  : shift + alt +   &larr;/	&rarr;*/}
                {/*</div>*/}
                <hr />
                {/*<div>*/}
                {/*    Adjust Vertical Positioning (CIP)<br/>*/}
                {/*    Position Top / Bottom (SCC): shift + alt +  ↑/↓*/}
                {/*</div>*/}
              </div>
            );
          },
        });
        break;
    }

    this.setState({ selectedMenu: item });
  }
  openExportView() {
    this.setState({ isShowExportView: true });
  }
  closeExportView() {
    this.setState({ isShowExportView: false });
  }
  closeVersionsView() {
    this.setState({ isShowVersionsView: false });
  }
  closeTimecodeShiftView() {
    this.setState({ isShowTimecodeShiftView: false });
  }

  openImportView() {
    this.setState({ isShowImportView: true });
  }

  closeImportView() {
    this.setState({ isShowImportView: false });
  }

  componentWillUnmount() {
    // this.props.ref(undefined)
  }

  componentDidMount() {
    // this.props.ref(this);

    //確認資料index 跟專案資料
    this.projectIndex = parseInt(this.props.match.params.tIndex, 10);
    this.projectprojectData =
      this.props.project.projectListData[this.projectIndex];

    try {
      console.log(
        `this.props.match.params.tType ${this.props.match.params.tType}`
      );
      if (this.props.match.params.tType !== undefined) {
        if (parseInt(this.props.match.params.tType, 10) === 0) {
          this.setState({ isEditMode: false });
          this.props.setIsEditMode(false);

          //移除Version切換
          let newmenus = this.state.menus;
          newmenus.splice(2, 1);
          this.setState({ menus: newmenus });
        } else if (parseInt(this.props.match.params.tType, 10) === 1) {
          this.setState({ isEditMode: true });
          this.props.setIsEditMode(true);
        }
      }
    } catch (err) {
      console.log(`componentDidMount ${err}`);
    }
  }

  async setVideoViewWidth() {
    this.props.set_subtitles_Left(600);
    this.props.set_viewWidth(600);
  }

  async showNav() {
    let checkNav = this.state.isShowPhoneNav;

    this.setState({ isShowPhoneNav: !checkNav });
  }

  async componentWillReceiveProps(nextProps) {
    // console.log(nextProps)

    if (parseInt(this.props.match.params.tType, 10) === 0) {
      await this.setState({ isEditMode: false });
    } else if (parseInt(this.props.match.params.tType, 10) === 1) {
      await this.setState({ isEditMode: true });
    }

    this.projectprojectData =
      nextProps.project.projectListData[this.projectIndex];
  }

  /*
   * go to line 的功能
   * */
  prompt() {
    this.props.setReadonly(true);

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui'>
            <Form>
              <Form.Field>
                <label>Please type line number</label>
                <input
                  autoFocus
                  ref={(input) => (this.lineNumberInput = input)}
                  placeholder='Please type line number'
                  onChange={(event) => {
                    // if(isNaN(parseFloat(event.target.value)) === false){
                    //
                    //
                    // }

                    this.setState({ lineNum: event.target.value });
                  }}
                />
              </Form.Field>
              <Button
                type='button'
                color='blue'
                //disabled={this.state.lineNum===null}

                onClick={() => {
                  const { lineNum } = this.state;

                  //更新cell選擇
                  let getRow = parseInt(parseFloat(lineNum) - 1, 10);

                  this.props.setDoubleClick(getRow);

                  this.props.closeTranslationsNavbarAlertView();

                  onClose();

                  this.props.setReadonly(false);
                }}
              >
                Submit
              </Button>
              <Button
                type='button'
                basic={true}
                onClick={() => {
                  this.props.closeTranslationsNavbarAlertView();

                  onClose();

                  this.props.setReadonly(false);
                }}
              >
                Cancel
              </Button>
            </Form>
          </div>
        );
      },
    });

    // this.messager.prompt({
    //     title: "Line number",
    //     msg: "Please type line number",
    //     result: lineNum => {
    //         if (lineNum) {
    //             // alert("you type: " + r);
    //             //更新cell選擇
    //             let getRow = parseInt(lineNum-1,10);
    //
    //             this.props.setDoubleClick(getRow);
    //
    //              this.props.closeTranslationsNavbarAlertView();
    //         }
    //     }
    // });
  }

  goToTimeline() {
    this.setState({ isShowTimeLinePop: true });
  }

  find() {
    return (
      <Menu>
        <MenuSep></MenuSep>

        <MenuItem
          onClick={() => {
            this.goToTimeline.bind(this);
          }}
          text='Go To Timeline'
        ></MenuItem>

        <MenuSep></MenuSep>
        <MenuItem text='Find'></MenuItem>
        <MenuSep></MenuSep>
        <MenuItem text='Spot QC'></MenuItem>
        <MenuItem text='Find Position and align'></MenuItem>
        <MenuItem text='Find Number'></MenuItem>
        <MenuItem text='Find Half-Width Character'></MenuItem>
        <MenuItem text='Find Italic'></MenuItem>
        <MenuSep></MenuSep>
        <MenuItem text='Frame Split Error'></MenuItem>
        <MenuItem text='Shot Change Error'></MenuItem>
        <MenuItem text='Encasing Mismatch Error'></MenuItem>

        <MenuSep></MenuSep>
      </Menu>
    );
  }

  //關閉Alert
  async closeTimeLineAlert() {
    await this.setState({ isShowTimeLinePop: false });
    // await this.setState({ TimeLinePopMessage: "" });
  }

  //關閉
  async closeHotKeyEventView() {
    await this.setState({ isShowHotKeyEventView: false });
  }

  //開啟藍色搜尋欄位
  async openBlueFind() {
    // await this.setState({ TimeLinePopMessage: "" });
  }

  async findAll() {
    // document.getElementById('FindAllView').style.display = 'block';

    //顯示input
    this.props.setIsShowFindAllViewInput(true);
    //
    this.props.closeTranslationsNavbarAlertView();
  }

  async findAllReplace() {
    //顯示
    //document.getElementById('FindAllView').style.display = 'block';

    //顯示input
    this.props.setIsShowFindAllViewReplace(true);

    this.props.closeTranslationsNavbarAlertView();
  }

  //客制取代
  async multipleFindReplace() {
    this.props.showHideMultipleView(true);

    this.props.closeTranslationsNavbarAlertView();
  }

  //取得位置與取代
  async findPositionAndAlign() {
    this.props.showFindPositionAndAlign(true);

    this.props.closeTranslationsNavbarAlertView();
  }

  async frameSplitError() {
    this.props.showFrameSplitError(true);

    this.props.closeTranslationsNavbarAlertView();
  }

  render() {
    const { menus, loading } = this.state;
    const { activeIndex } = this.state;

    let {
      isShowImportView,
      isShowExportView,
      isShowVersionsView,
      isShowTimecodeShiftView,
      isShowRunZerotime,
    } = this.state;

    /**
     * 開啟 Timecode shift 設定
     * */
    const TimecodeShiftAlertView = (
      <Popup
        open={isShowTimecodeShiftView}
        modal
        closeOnDocumentClick
        onClose={this.closeTimecodeShiftView}
        contentStyle={{ width: '800px' }}
      >
        <SubtitleContext.Consumer>
          {(context) => (
            <TimecodeShiftMainView
              closeTranslationsNavbarAlertView={
                this.props.closeTranslationsNavbarAlertView
              }
              onClose={this.closeTimecodeShiftView}
              context={context}
              projectDetial={this.props.projectDetial}
            />
          )}
        </SubtitleContext.Consumer>
      </Popup>
    );

    /**
     * 開啟 Zerotime 設定
     * */
    const RunZerotimeAlertView = (
      <Popup
        open={isShowRunZerotime}
        modal
        closeOnDocumentClick
        onClose={() => {
          this.setState({ isShowRunZerotime: false });
        }}
        contentStyle={{ width: '800px' }}
      >
        <SubtitleContext.Consumer>
          {(context) => (
            <ZeroTimeMainView
              context={context}
              closeTranslationsNavbarAlertView={
                this.props.closeTranslationsNavbarAlertView
              }
              projectDetial={this.props.projectDetial}
            />
          )}
        </SubtitleContext.Consumer>
      </Popup>
    );

    /**
     * 開啟輸入畫面
     * */
    const ImportAlertView = (
      <Popup
        open={isShowImportView}
        modal
        closeOnDocumentClick
        onClose={this.closeImportView}
        contentStyle={{ width: '600px' }}
      >
        <SubtitleContext.Consumer>
          {(context) => (
            <ImportView
              context={context}
              projectData={this.props.projectData}
              projectDetial={this.props.projectDetial}
              updateEditTableData={(newData) => {
                this.props.updateEditTableData(newData);
              }}
              closeImportView={this.closeImportView}
            />
          )}
        </SubtitleContext.Consumer>
      </Popup>
    );

    /**
     * 開啟輸出畫面
     * */
    const ExportAlertView = (
      <Popup
        open={isShowExportView}
        modal
        closeOnDocumentClick
        onClose={this.closeExportView}
        contentStyle={{ width: '600px' }}
      >
        <ExportView closeExportView={this.closeExportView} />
      </Popup>
    );

    /**
     * 開啟版本控制
     * */
    const VersionsAlertView = (
      <Popup
        open={isShowVersionsView}
        modal
        closeOnDocumentClick
        onClose={this.closeVersionsView}
        contentStyle={{ width: '600px' }}
      >
        <SubtitleContext.Consumer>
          {(context) => (
            <Versions
              context={context}
              onClose={this.closeVersionsView}
              findFrameSplitValue={this.props.findFrameSplitValue}
              videoFps={this.props.videoFps}
            />
          )}
        </SubtitleContext.Consumer>
      </Popup>
    );

    /**
     * 玩家選擇TimeLine Alert
     * */
    const TimeLineAlertView = (
      <TimeLinePop
        closeTranslationsNavbarAlertView={
          this.props.closeTranslationsNavbarAlertView
        }
        setDoubleClick={this.props.setDoubleClick}
        isOpen={this.state.isShowTimeLinePop}
        message={this.state.TimeLinePopMessage}
        closeAlert={this.closeTimeLineAlert}
        contentStyle={{ width: '300px' }}
      />
    );

    /**
     * 熱鍵
     * */
    const HotKeyEventView = (
      <Popup
        open={this.state.isShowHotKeyEventView}
        modal
        closeOnDocumentClick
        onClose={this.closeHotKeyEventView}
        contentStyle={{ width: '600px' }}
      >
        <SubtitleContext.Consumer>
          {
            (context) => (
              <div className='custom-ui p-4'>
                <div>
                  Play /Pause :{/* ctrl + ↓ (Mac: command + ↓) */}
                  <div style={{ paddingLeft: '10px' }}>
                    <input
                      type='radio'
                      name='PlayPauseHoykey'
                      value={'Shift + Space'}
                      checked={this.state.PlayPauseHoykey === 0 ? true : false}
                      onChange={() => {
                        this.setState({ PlayPauseHoykey: 0 });
                        localStorage.setItem('PlayPauseHoykey', 0);
                      }}
                      onClick={() => {
                        this.setState({ PlayPauseHoykey: 0 });
                        localStorage.setItem('PlayPauseHoykey', 0);
                      }}
                    />{' '}
                    Shift + Space
                  </div>
                  <div style={{ paddingLeft: '10px' }}>
                    <input
                      type='radio'
                      name='PlayPauseHoykey'
                      value={'Ctrl + ↓'}
                      checked={this.state.PlayPauseHoykey === 1 ? true : false}
                      onChange={() => {
                        this.setState({ PlayPauseHoykey: 1 });
                        localStorage.setItem('PlayPauseHoykey', 1);
                      }}
                      onClick={() => {
                        this.setState({ PlayPauseHoykey: 1 });
                        localStorage.setItem('PlayPauseHoykey', 1);
                      }}
                    />{' '}
                    Ctrl + ↓
                  </div>
                </div>
                <div>
                  Play From Selected Row :
                  {/* ctrl + &rarr; (Mac: command + &rarr;) */}
                  <div style={{ paddingLeft: '10px' }}>
                    <input
                      type='radio'
                      name='PlayFromSelectedRow'
                      value={'Option + Space '}
                      checked={
                        this.state.PlayFromSelectedRow === 0 ? true : false
                      }
                      onChange={this.PlayFromSelectedRowChange}
                    />{' '}
                    Option + Space
                  </div>
                  <div style={{ paddingLeft: '10px' }}>
                    <input
                      type='radio'
                      name='PlayFromSelectedRow'
                      value={'Ctrl + left'}
                      checked={
                        this.state.PlayFromSelectedRow === 1 ? true : false
                      }
                      onChange={this.PlayFromSelectedRowChange}
                    />{' '}
                    Ctrl + &rarr;
                  </div>
                </div>
                <div>
                  Jump Backward / Forward 5 sec. : Shift + &larr;/ &rarr;
                </div>
                <div>Pause At Selected Row : Alt + P</div>
                <hr />
                <div>Capture Timecode : Enter</div>
                <hr />
                <div>Insert Row Above : Ctrl + I (Mac: Command + I)</div>
                <div>Delete Row : Ctrl + D (Mac: Command + D)</div>
                <div>Row Split : Ctrl + Alt + S (Mac: Command + Shift + S)</div>
                <div>Row Merge : Ctrl + Alt + M (Mac: Command + Shift + M)</div>
                <hr />
                <div>Italic : Alt + I / Ctrl + Alt + I</div>
                <div>Add Music Note : Alt + M (Mac: Option + M)</div>
                <hr />
                <div>
                  Position Left/Right : Alt + &larr;/ &rarr; (Mac: Option +
                  &larr;/ &rarr;)
                </div>
                <div>Position Up/Down : Alt + ↑/↓ (Mac: Option + ↑/↓)</div>
                {/*<div>*/}
                {/*    Align Left / Right (SCC)  : shift + alt +   &larr;/	&rarr;*/}
                {/*</div>*/}
                <hr />
                {/*<div>*/}
                {/*    Adjust Vertical Positioning (CIP)<br/>*/}
                {/*    Position Top / Bottom (SCC): shift + alt +  ↑/↓*/}
                {/*</div>*/}
              </div>
            )
            // <ImportView context={context}
            //             updateEditTableData={(newData)=>{
            //                 this.props.updateEditTableData(newData);
            //             }}
            // closeImportView={this.closeHotKeyEventView}/>
          }
        </SubtitleContext.Consumer>
      </Popup>
    );

    return loading === false ? (
      <div data-test='component-TranslationsNavbar'>
        {loading === true ? (
          <Spinner />
        ) : (
          <div id='LeftTopMenu'>
            <Accordion>
              {menus.map((data, index) => {
                const { text, children } = data;

                return (
                  <div key={index}>
                    <Accordion.Title
                      active={activeIndex === index}
                      index={index}
                      onClick={this.handleClick}
                    >
                      <Icon name='dropdown' />
                      {text}
                    </Accordion.Title>
                    <Accordion.Content active={activeIndex === index}>
                      {children.map((children_data, c_index) => {
                        const { text } = children_data;

                        return (
                          <div
                            className={'pl-3 pb-2'}
                            key={c_index}
                            onClick={() => {
                              this.handleItemClick(children_data);
                            }}
                          >
                            <p className='LeftTopMenuContent'>{text}</p>
                          </div>
                        );
                      })}
                    </Accordion.Content>
                  </div>
                );
              })}
            </Accordion>
          </div>
        )}

        <Messager ref={(ref) => (this.messager = ref)} />

        {TimeLineAlertView}

        {ImportAlertView}

        {ExportAlertView}

        {VersionsAlertView}

        {TimecodeShiftAlertView}

        {RunZerotimeAlertView}

        {HotKeyEventView}
      </div>
    ) : (
      <Spinner />
    );
  }
}

TranslationsNavbar.propTypes = {};

const mapStateToProps = (state) => ({
  project: state.project,
  viewOperation: state.viewOperation,
  editTable: state.editTable,
});

export default connect(mapStateToProps, {
  signUser,
  setIsShowFindAllViewInput,
  setIsEditMode,
  setIsShowFindAllViewReplace,
  showHideMultipleView,
  showFindPositionAndAlign,
  showFrameSplitError,
  set_subtitles_Left,
  set_viewWidth,
  show_source_language,
  hide_source_language,
  show_hide_Shot_Change,
  showHidePositionList,
  setTableColWidth,
  AddDetialJsonData,
  setIsEdit,
  updateFindFrameTargetData,
  setReadonly,
})(withRouter(TranslationsNavbar));



// WEBPACK FOOTER //
// ./src/components/layout/TranslationsNavbar.js